import { PasswordTermsCheckIcon, PasswordTermsFailIcon } from '@icons'
import cn from 'classnames'

interface Props {
  empty: boolean
  valid: boolean
  caption: string
}

function CheckBullet({ empty, valid, caption }: Props) {
  return (
    <div className={cn('circle-wrapper', { 'not-done': !valid })}>
      <span className='icon'>
        {empty ? <div className='circle' /> : valid ? <PasswordTermsCheckIcon /> : <PasswordTermsFailIcon />}
      </span>
      <span>{caption}</span>
    </div>
  )
}

export default CheckBullet
